// BidangPsma.js
import React, { useState, useRef, useEffect } from "react";
import "../../assets/css/LayananPublik.css";
import Tabs from "../profile/DetailProfilBidang"; // Impor komponen Tabs
import Banner from "../../components/Banner";
import LogoDisdik from "../../assets/logo-apps/Logo fix full color.png";
import MaskotDisdik from "../../assets/logo-apps/MASCOT DISDIK 7-04.png";
import MaskotDisdik2 from "../../assets/logo-apps/MASCOT 4-06.png";
import MaskotDisdik3 from "../../assets/logo-apps/MASCOT DISDIK 2-01.png";
import LogoTrasnformasi from "../../assets/logo-apps/Transformasi.png";
import LogoKupuKupu from "../../assets/logo-apps/Kupukupu.png";
import LogoLaptop from "../../assets/logo-apps/laptop.png";
import LogoNaungan from "../../assets/logo-apps/Naungan.png";
import LogoBuku from "../../assets/logo-apps/Buku.png";
import LogoLingkaran from "../../assets/logo-apps/Lingkaran.png";
import LogoLTunas from "../../assets/logo-apps/Tunas.png";

import LogoTikomdik from "../../assets/logo-apps/logo-kcd/LOGO TIKOMDIK.png"
import LogoKCD1 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-01.png"
import LogoKCD2 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-02.png"
import LogoKCD3 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-03.png"
import LogoKCD4 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-04.png"
import LogoKCD5 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-05.png"
import LogoKCD6 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-06.png"
import LogoKCD7 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-07.png"
import LogoKCD8 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-08.png"
import LogoKCD9 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-09.png"
import LogoKCD10 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-10.png"
import LogoKCD11 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-11.png"
import LogoKCD12 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-12.png"
import LogoKCD13 from "../../assets/logo-apps/logo-kcd/LOGO CABANG DINAS-13.png"


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";

const cardData = [
  {
    id: 1,
    title: "Transformasi",
    description:
      "Spirit untuk terus melakukan perbaikan tidak hanya melalui adaptasi teknologi dalam pendidikan, tetapi juga komitmen-komitmen membangun kualitas dan kuantitas sumber daya manusia secara berkesimnambungan sesuai dengan derap zaman ",
    imageUrl: LogoTrasnformasi,
  },
  {
    id: 2,
    title: "Kupu Kupu",
    description:
      "Melambangkan perjuangan dan kebebebasan. Perjuangan menggapai cita-cita dengan kesabaran dan kegigihan mengikuti proses untuk berubah menjadi pribadi yang lebih baik. Kebebasan dalam berpikir dan berkreativitas.",
    imageUrl: LogoKupuKupu,
  },
  {
    id: 3,
    title: "Laptop",
    description:
      "Simbol digitalisasi dan wujud komitmen dalam berinovasi tanpa henti dalam hal mutu pembelajaran maupun tatakelola manajemen pendidikan demi terwujudnya masa depan pendidikan yang semakin baik di Jawa Barat.",
    imageUrl: LogoLaptop,
  },
  {
    id: 4,
    title: "Naungan",
    description: `Naungan melambangkan Disdik Jabar sebagai perlindungan bagi semua stakeholder pendidikan.  Disdik Jabar berupaya menjaga dan meningkatkan kualitas pendidikan dengan prinsip kolaborasi penta-helix.`,
    imageUrl: LogoNaungan,
  },
  {
    id: 5,
    title: "Buku",
    description:
      "Melambangkan ilmu pengetahuan yang senantiasa berkembang, dan selalu membawa manfaat bagi kesejahteraan umat manusia. Buku adalah simbol majunya peradaban dan pendidikan disebuah daerah.",
    imageUrl: LogoBuku,
  },
  {
    id: 6,
    title: "Lingkaran",
    description:
      "Lingkaran melambangkan kesempurnaan dan pergerakan yang dinamis. Disdik Jabar selalu dinamis menyesuaikan dengan perkembangan zaman, namun tetap menjaga standar untuk mewujudkan kesempurnaan cita- cita pendidikan.",
    imageUrl: LogoLingkaran,
  },
];

const cardData2 = [
  {
    id: 1,
    title: "Tunas",
    description: `Tunas adalah simbol pertumbuhan yang bergantung pada berbagai faktor penunjang untuk mencapai hasil yang optimal. Demikian pula, spirit “Terdidik Terbaik” adalah proses untuk membina generasi unggul di masa depan guna meningkatkan kualitas pendidikan.`,
    imageUrl: LogoLTunas,
  },
];

const logos = [
  {
    src: LogoTikomdik,
    alt: "Logo Tikomdik",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD1,
    alt: "Logo KCD 1",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD2,
    alt: "Logo KCD 2",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD3,
    alt: "Logo KCD 3",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD4,
    alt: "Logo KCD 4",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD5,
    alt: "Logo KCD 5",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD6,
    alt: "Logo KCD 6",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD7,
    alt: "Logo KCD 7",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD8,
    alt: "Logo KCD 8",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD9,
    alt: "Logo KCD 9",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD10,
    alt: "Logo KCD 10",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD11,
    alt: "Logo KCD 11",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD12,
    alt: "Logo KCD 12",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  {
    src: LogoKCD13,
    alt: "Logo KCD 13",
    downloadLink:
      "https://drive.google.com/drive/folders/1xihFF2vQoD7yborDZAAwpZmQ5XP6ZcDI?usp=drive_link",
    buttonText: "Unduh Logo",
  },
  // Tambahkan data lainnya di sini...
];



function TabContent1() {
  return (
    <div className="tab-content fade-in mb-4">
      <div
        className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
      >
        <div className="section-heading">
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <img
                width={500}
                height={500}
                src={LogoDisdik}
                className="img-fluid"
                alt="..."
              />
            </div>

            <div className="custom-text d-flex justify-content-center mt-3">
              <a
                className="btn btn-custom-home btn-md "
                download
                href={
                  "https://api-webdisdik.jabarprov.go.id/api/v2/publik/files/download/9e3480ef-4f64-44f6-ba4b-982dece668df"
                }
              >
                Unduh Logo
              </a>
            </div>

            <div className="col-12 custom-text mt-4">
              <div className="custom-text">
                <h5>Filosofi Logo </h5>
              </div>
              <ol>
                <li>
                  <p>
                    Menggambarkan sebuah perpaduan antara buku, laptop, dan
                    kupu-kupu. Melambangkan ilmu pengetahuan yang senantiasa
                    berkembang, dan juga menunjukan tradisi belajar
                    lisan,tulisan dan digital yang membawa manfaat bagi
                    kesejahteraan umat manusia.
                  </p>
                </li>
                <li>
                  <p>
                    Simbol majunya peradaban dan komitmen dalam berinovasi tanpa
                    henti pada mutu pembelajaran maupun tatakelola manajemen
                    pendidikan untuk melahirkan generasi “terdidik”, demi
                    terwujudnya masa depan pendidikan yang “terbaik” yang
                    ditopang kualitas SDM yang merata dan berkesinambungan.
                  </p>
                </li>
                <li>
                  <p>
                    Proses metamorfosa yang ada pada kupu-kupu juga menjadi
                    wujud spirit perubahan dari yang biasa menjadi luar biasa,
                    dari yang dibenci menjadi dicinta. Dengan input proses dan
                    output yang terdidik terbaik pendidikan mampu memperbaiki
                    masa depan dan memutus rantai kemiskinan.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div className="container mt-4 mb-4">
          <div className="custom-text">
            <h5>Makna Logo</h5>
          </div>
          <div className="row mt-5">
            {cardData.map((card, index) => (
              <div className="col-lg-6 col-md-6 col-sm-12" key={index}>
                <div
                  className="profile-logo profile-item-logo "
                  style={{ height: "100%" }}
                >
                  <div className="profile-smallimg">
                    <div className="profile__image">
                      <div className="profile__border__logo">
                        <img src={card.imageUrl} alt="Doggo" width="80" />
                      </div>
                    </div>
                    <div className="profile__logo">
                      <h5>{card.title}</h5>
                      <p>{card.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="row mt-4">
            {cardData2.map((card, index) => (
              <div className="col-lg-12 col-md-12 col-sm-12" key={index}>
                <div
                  className="profile-logo profile-item-logo "
                  style={{ height: "100%" }}
                >
                  <div className="profile-smallimg">
                    <div className="profile__image">
                      <div className="profile__border__logo">
                        <img src={card.imageUrl} alt="Doggo" width="80" />
                      </div>
                    </div>
                    <div className="profile__logo">
                      <h5>{card.title}</h5>
                      <p>{card.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function TabContent2() {
  return (
    <div className="tab-content fade-in mb-4">
      <div
        className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
      >
        <div className="section-heading">
          <div className="row">
            <div className="col-4 d-flex justify-content-center">
              <img
                width={500}
                height={500}
                src={MaskotDisdik}
                className="img-fluid"
                alt="..."
              />
            </div>
            <div className="col-4 d-flex justify-content-center">
              <img
                width={500}
                height={500}
                src={MaskotDisdik2}
                className="img-fluid"
                alt="..."
              />
            </div>
            <div className="col-4 d-flex justify-content-center">
              <img
                width={500}
                height={500}
                src={MaskotDisdik3}
                className="img-fluid"
                alt="..."
              />
            </div>
            <div className="custom-text d-flex justify-content-center mt-3">
              <a
                className="btn btn-custom-home btn-md "
                href={
                  "https://api-webdisdik.jabarprov.go.id/api/v2/publik/files/download/307564cd-2aaa-43d3-9ecc-35191f6cd21e"
                }
              >
                Unduh Maskot
              </a>
            </div>

            <div className="col-12 custom-text mt-4">
              <h5>DIBA Maskot</h5>
              <ol style={{ listStyleType: "circle" }}>
                <li>
                  <p>
                    {" "}
                    DIBA Berupa Karakter yang menggambarkan sosok Terdidik dan
                    Terbaik serta Menjadi ciri SDM Unggul Pendidikan Di Jawa
                    Barat .
                  </p>
                </li>
                <li>
                  <p>
                    {" "}
                    Sosok DIBA Terdiri dari Unsur – Unsur Yang berbeda dan
                    saling berkaitan antara lain Pensil, Stylus, Lebah, dan
                    Robot.
                  </p>
                </li>
                <li>
                  <p>
                    DIBA adalah sebagai perlambangan dalam unsur hubungan antara
                    manusia, alam dan teknologi dan konteks kehidupan yang
                    kompleks dan dinamis .
                  </p>
                </li>
              </ol>
            </div>
            <div className="col-12 custom-text mt-4">
              <h5>Filosofi Maskot</h5>
              <ol style={{ listStyleType: "circle" }}>
                <li>
                  <p>
                    {" "}
                    Pensil melambangkan makna keilmuan, pertumbuhan dan
                    sosialisasi dalam kehidupan manusia. Pensil digunakan ketika
                    menjalani proses pendidikan sehingga menjadi siswa yang
                    terdidik. Dalam era digital, pensil juga dapat melambangkan
                    integrasi teknologi. Pensil digital atau stylus dapat
                    digunakan untuk membuat seni digital atau bekerja pada
                    perangkat elektronik, melambangkan tradisi belajar tulisan
                    dan digital.
                  </p>
                </li>
                <li>
                  <p>
                    {" "}
                    Lebah melambangkan Berkarakter, etos kerja, manfaat, dan
                    dampak positif dalam ekosistem alam.
                  </p>
                </li>
                <li>
                  <p>
                    {" "}
                    Robot melambangkan keahlian dalam teknologi, inovasi, dan
                    kemajuan dalam kehidupan modern.
                  </p>
                </li>
                <li>
                  <p>
                    {" "}
                    Ketiga unsur ini adalah sebagai perlambangan dalam hubungan
                    antara manusia, alam, dan teknologi dalam konteks kehidupan
                    yang kompleks dan dinamis, sehingga dapat menuju generasi
                    terdidik dan terbaik di 2045.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TabContent5() {
  return (
    <div className="tab-content fade-in mb-4">
      <div
        className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
      >
        <div className="section-heading">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 custom-text text-center">
              <h5>
                <span className="highlight-terdidik text-center">
                  Terdidik sekarang{" "}
                </span>{" "}
                <span className="highlight-terbaik text-center">
                  Terbaik mendatang{" "}
                </span>
              </h5>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 custom-text text-center mt-3">
              {" "}
              <h5>
                <span className="highlight-terdidik">#terdidik </span>{" "}
                <span className="highlight-terbaik">#terbaik </span>
              </h5>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 custom-text text-center">
              {" "}
              <h5>
                <span className="highlight-terdidik">
                  #terdidik<span className="highlight-terbaik">terbaik </span>
                </span>{" "}
              </h5>
            </div>
            <div className="custom-text d-flex justify-content-center mt-3"></div>

            <div className="col-12 custom-text mt-4">
              {/* <h6>Filosofi</h6> */}
              <p>
                {" "}
                <span className="highlight-terdidik">Terdidik</span> dan{" "}
                <span className="highlight-terbaik">Terbaik</span> mengacu pada
                kondisi dan keadaan "kini dan nanti". Bahwa hasil pendidikan
                akan terasa pada sekian tahun mendatang, bisa dimulai hari ini
                dengan menjalankan proses pembentukan karakter, pendalaman ilmu
                dan penajaman keahlian guna menjadi yang terbaik dimasa
                mendatang. <span className="highlight-terdidik">Terdidik</span>{" "}
                dan <span className="highlight-terbaik">Terbaik</span> dapat
                berupa input, proses maupun output.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TabContent3() {
  const songTitle = "Jingle Disdik Jabar";
  const [newAudio, setNewAudio] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isRender, setRendered] = useState(false);
  const [libraryIsPlaying, setLibraryIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  }, [isPlaying]);

  useEffect(() => {
    const updateCurrentTime = () => {
      setCurrentTime(audioRef.current.currentTime);
    };

    const setAudioDuration = () => {
      setDuration(audioRef.current.duration);
    };

    audioRef.current.volume = 0.6;
    audioRef.current.addEventListener("timeupdate", updateCurrentTime);
    audioRef.current.addEventListener("loadedmetadata", setAudioDuration);
    audioRef.current.addEventListener("ended", handleAudioEnded);

    return () => {
      audioRef.current.volume = 0.6;
      audioRef.current.removeEventListener("timeupdate", updateCurrentTime);
      audioRef.current.removeEventListener("loadedmetadata", setAudioDuration);
      audioRef.current.removeEventListener("ended", handleAudioEnded);
    };
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const handleSeek = (event) => {
    const newTime = (event.target.value / 100) * duration;
    audioRef.current.currentTime = newTime;
  };

  const handleAudioEnded = () => {
    setIsPlaying(false); // Pause when the audio ends
  };
  const lyrics = `
  [Verse 1]
  KINI… NANTI
  KITA BELAJAR
  KINI NANTI
  JADI TERPELAJAR
  
  SIAP HADAPI TANTANGAN
  BERSELANCAR DALAM PERUBAHAN
  
  [Reff 1]
  DISDIKJABAR BERINOVASI
  DI DISDIK JABAR KOLABORASI
  SEMUA BERSIAP
  GENERASI UNGGUL
  GENERASI EMAS
  TERDIDIK TERBAIK
  
  [Verse 2]
  KINI… NANTI
  TANGGUH DAN SEHAT
  KINI NANTI
  TERKAJI TERUJI
  
  DAN KAN SLALU BERSYUKUR
  BERSAMA MERAIH KABAGJAAN
  
  [Reff 2]
  DI DISDIK JABAR BERKREASI
  DI DISDIK JABAR BERPRESTASI
  SEMUA BERSIAP
  GENERASI UNGGUL
  GENERASI EMAS
  TERDIDIK TERBAIK
  

`;
  return (
    <div className="tab-content fade-in">
      <div
        className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <audio
                ref={audioRef}
                src={
                  "https://api-webdisdik.jabarprov.go.id/api/v2/publik/files/download/a7e50b22-9f44-4241-8147-6987cb0c013c"
                }
              />
              <div className="img-box d-flex justify-content-center">
                <div className="media-player-custom">
                  <div className="image-cover">
                    <div className="icon">
                      <img
                        src={LogoDisdik}
                        width={200}
                        height={100}
                        style={{ marginInline: "2rem" }}
                      />
                    </div>
                  </div>
                  <div className="media-player-indicator">
                    <input
                      className="media-range"
                      type="range"
                      min="0"
                      max="100"
                      step="0.01"
                      value={(currentTime / duration) * 100}
                      onChange={handleSeek}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="media-duration">
                    <div>{formatTime(currentTime)}</div>
                    <div>{formatTime(duration)}</div>
                  </div>
                  <div className="media-play-btn">
                    <span
                      className="icon"
                      onClick={() => setIsPlaying(!isPlaying)}
                    >
                      {isPlaying ? (
                        <FontAwesomeIcon icon={faPause} size="2x" />
                      ) : (
                        <FontAwesomeIcon icon={faPlay} size="2x" />
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="lyrics-container">
                <pre>{lyrics}</pre>
              </div>
            </div>

            <div className="custom-text d-flex justify-content-center mt-4">
              <a
                className="btn btn-custom-home btn-md"
                href={
                  "https://api-webdisdik.jabarprov.go.id/api/v2/publik/files/download/a7e50b22-9f44-4241-8147-6987cb0c013c"
                }
              >
                Unduh Jingle
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TabContent4() {
  const songTitle = "Jingle Disdik Jabar";
  const [newAudio, setNewAudio] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isRender, setRendered] = useState(false);
  const [libraryIsPlaying, setLibraryIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  }, [isPlaying]);

  useEffect(() => {
    const updateCurrentTime = () => {
      setCurrentTime(audioRef.current.currentTime);
    };

    const setAudioDuration = () => {
      setDuration(audioRef.current.duration);
    };

    audioRef.current.volume = 0.6;
    audioRef.current.addEventListener("timeupdate", updateCurrentTime);
    audioRef.current.addEventListener("loadedmetadata", setAudioDuration);
    audioRef.current.addEventListener("ended", handleAudioEnded);

    return () => {
      audioRef.current.volume = 0.6;
      audioRef.current.removeEventListener("timeupdate", updateCurrentTime);
      audioRef.current.removeEventListener("loadedmetadata", setAudioDuration);
      audioRef.current.removeEventListener("ended", handleAudioEnded);
    };
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const handleSeek = (event) => {
    const newTime = (event.target.value / 100) * duration;
    audioRef.current.currentTime = newTime;
  };

  const handleAudioEnded = () => {
    setIsPlaying(false); // Pause when the audio ends
  };
  return (
    <div className="tab-content fade-in">
      <div
        className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
      >
        <div className="">
          <div>
            <audio
              ref={audioRef}
              src={
                "https://api-webdisdik.jabarprov.go.id/api/v2/publik/files/download/3ef907d5-f2a3-4e4c-a447-af33b83224ef"
              }
            />
            <div className="img-box d-flex justify-content-center">
              <div className="media-player-custom ">
                <div className="image-cover">
                  <div className="icon">
                    <img
                      src={LogoDisdik}
                      width={200}
                      height={100}
                      style={{ marginInline: "2rem" }}
                    />
                  </div>
                </div>
                <div className="media-player-indicator">
                  <input
                    className="media-range"
                    type="range"
                    min="0"
                    max="100"
                    step="0.01"
                    value={(currentTime / duration) * 100}
                    onChange={handleSeek}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="media-duration">
                  <div>{formatTime(currentTime)}</div>
                  <div>{formatTime(duration)}</div>
                </div>
                <div className="media-play-btn">
                  <span
                    className="icon"
                    onClick={() => setIsPlaying(!isPlaying)}
                  >
                    {isPlaying ? (
                      <FontAwesomeIcon icon={faPause} size="2x" />
                    ) : (
                      <FontAwesomeIcon icon={faPlay} size="2x" />
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="custom-text d-flex justify-content-center mt-4">
            <a
              className="btn btn-custom-home btn-md fw-bold"
              href={
                "https://api-webdisdik.jabarprov.go.id/api/v2/publik/files/download/3ef907d5-f2a3-4e4c-a447-af33b83224ef"
              }
            >
              Unduh Ringtone
            </a>
          </div>

          {/* <div className="col">
                <div>
                  <h2>{songTitle}</h2> 
                  <audio ref={audioRef} src={mp3Url}></audio>
                  <button onClick={togglePlay}>
                    {isPlaying ? "Pause" : "Play"}
                  </button>
                </div>
              </div> */}
        </div>
      </div>
    </div>
  );
}

function TabContent6() {
  return (
    <div className="tab-content fade-in mb-4">
    <div
      className={`tab-pane fade shadow rounded bg-white show active p-5 mt-2 animated backInUp`}
    >
      <div className="section-heading">
        <div className="row">
          {logos.map((logo, index) => (
            <div
              key={index}
              className="col-4 d-flex flex-column align-items-center"
            >
              <img
                width={500}
                height={500}
                src={logo.src}
                className="img-fluid"
                alt={logo.alt}
              />
              <a
                className="btn btn-custom-home btn-md mt-3 mb-5"
                href={logo.downloadLink}
              >
                {logo.buttonText}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
  
  );
}

const tabs = [
  { id: "tab1", label: "Logo Disdik" },
  { id: "tab6", label: "Logo Cadisdik dan UPTD Tikomdik" },
  { id: "tab2", label: "Maskot Disdik" },
  { id: "tab5", label: "Tagline" },
  { id: "tab3", label: "Jingle Disdik" },
  { id: "tab4", label: "Ringtone Disdik" },
];

function Lambang() {
  const [isFollowing, setIsFollowing] = useState(false);
  const elementToFollowRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (elementToFollowRef.current) {
        const elementRect = elementToFollowRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Hitung posisi elemen relatif terhadap posisi scroll dan tinggi layar
        const distanceFromTop = elementRect.top - windowHeight;

        // Tentukan apakah elemen sudah mencapai posisi akhirnya
        const shouldFollow = distanceFromTop <= 0;

        // Perbarui state isFollowing
        setIsFollowing(shouldFollow);
      }
    };

    // Tambahkan event listener untuk scroll
    window.addEventListener("scroll", handleScroll);

    // Bersihkan event listener saat komponen tidak lagi digunakan
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      {" "}
      <Banner
        menu={"Tentang Brand Identity"}
        desc={
          "Menyajikan informasi mengenai Logo, Maskot, Jinggle dan Ringtone Dinas Pendidikan Jawa Barat"
        }
      />
      <Tabs tabs={tabs} defaultTab="tab1">
        {(activeTab) => {
          if (activeTab === "tab1") {
            return <TabContent1 />;
          } else if (activeTab === "tab2") {
            return <TabContent2 />;
          } else if (activeTab === "tab3") {
            return <TabContent3 />;
          } else if (activeTab === "tab4") {
            return <TabContent4 />;
          } else if (activeTab === "tab5") {
            return <TabContent5 />;
          } else if (activeTab === "tab6") {
            return <TabContent6 />;
          }
        }}
      </Tabs>
    </>
  );
}

export default Lambang;
